import Vue from 'vue';

import formatNir from './formatNir';

// Register global filters
Vue.filter('formatNir', formatNir);
